import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline'

import { Statused } from 'types/ui'

export function StatusSymbol(props: Statused) {
  switch (true) {
    case props.error:
      return (
        <XCircleIcon
          data-testid='status-symbol.error'
          className='w-4 h-4 stroke-2 stroke-error'
        />
      )
    case props.warning:
      return (
        <ExclamationTriangleIcon
          data-testid='status-symbol.warning'
          className='w-4 h-4 stroke-2 stroke-warning'
        />
      )
    case props.success:
      return (
        <CheckCircleIcon
          data-testid='status-symbol.success'
          className='w-4 h-4 stroke-2 stroke-success'
        />
      )
    default:
      return null
  }
}
